import { render, staticRenderFns } from "./link-service.vue?vue&type=template&id=68b7495f&"
import script from "./link-service.vue?vue&type=script&lang=js&"
export * from "./link-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports